import _ from "lodash";
const getters = {
  getFilterData: (state) => {
    return state.default_meetting_filter;
  },
  getMeetings: (state) => {
    return state.meetingsList;
  },
  getFilteredResult: (state) => {
    const meetingLists = state.meetingsList.filter((repository) => {
      if (repository.scheduletStartTimeInUTC) {
        const start_date = new Date(repository.scheduletStartTimeInUTC)
          .toISOString()
          .substr(0, 10);
        if (state.default_meetting_filter) {
          if (
            state.default_meetting_filter.filter_type == "upcoming" &&
            new Date(repository.scheduledEndTimeInUTC) >= new Date()
          ) {
            return repository;
          } else if (
            state.default_meetting_filter.filter_type != "upcoming" &&
            start_date >= state.default_meetting_filter.start_date &&
            start_date <= state.default_meetting_filter.end_date
          ) {
            return repository;
          }
        } else {
          return repository;
        }
      }
    });

    return meetingLists;
  },
  getUpcommingMeetings: (state) => {
    return state.upcommingMeetingList;
  },
  getMeetingTypeId: (state) => {
    if (state.meetingDetails) {
      return state.meetingDetails.meetingTypeId;
    }
    return null;
  },

  getMeetingComments: (state) => {
    const sortedMeetingCommentList = _.orderBy(
      state.meetingCommentList,
      ["createdDate"],
      ["asc"]
    );
    return sortedMeetingCommentList;
  },
  getMomLogs: (state) => {
    const sortedMeetinglogs = _.orderBy(
      state.meetingMomLogs,
      ["updated_time"],
      ["asc"]
    );
    return sortedMeetinglogs;
  },
  getResolutionTypesList: (state) => {
    return state.resolutionTypesList.map(item => ({ label: state.i18n.t(item.translationKey), value: item.value }))
  },
};

export default getters;
